<template>
  <div class="activity-widget">
    <div class="flex-container widget-content">
      <div class="flex-column" style="flex: 2; min-width: 55%;">
        
        <!-- Activity header -->
        <h1 class="blue-text activity-title">{{ eventName }}</h1>
        <button
          class="book-now"
          v-on:click="scrollToBooking">
          {{ getTranslation('BOOK_NOW') }}
        </button>
        <p style="margin: 0px; margin-bottom: -5px;">{{ excerpt }}</p>
        <div class="event-details">
          <img v-if="eventLength" class="small-icon" alt="clock" :src="require('../assets/clock.png')" />
          <p v-if="eventLength" class="event-detail">{{ minutesToTime(eventLength) }}</p>
          <img v-if="eventDifficulty" class="small-icon" alt="difficulty" :src="translateDifficultyImg(eventDifficulty)" />
          <p class="event-detail">{{ translateDifficulty(eventDifficulty) }}</p>
        </div>

        <!-- Tab buttons -->
        <div class="tab-selector">
          <button
            v-if="eventDescriptionText"
            :class="{
              'tab-button': true,
              'selected-tab': selectedTabIndex === 0}"
            v-on:click="setSelectedTabIndex(0)">
            {{ getTranslation('DESCRIPTION') }}
          </button>
          <button
            v-if="startPoints && startPoints.length > 0"
            :class="{
              'tab-button': true,
              'selected-tab': selectedTabIndex === 1}"
            v-on:click="setSelectedTabIndex(1)">
            {{ getTranslation('MEETING_PLACES') }}
          </button>
          <button
            v-if="pickupPlaces && pickupPlaces.length > 0"
            :class="{
              'tab-button': true,
              'selected-tab': selectedTabIndex === 2}"
            v-on:click="setSelectedTabIndex(2)">
            {{ getTranslation('PICKUP_PLACES') }}
          </button>
          <button
            v-if="eventItenary && eventItenary.length !== 0"
            :class="{
              'tab-button': true,
              'selected-tab': selectedTabIndex === 3}"
            v-on:click="setSelectedTabIndex(3)">
            {{ getTranslation('ITENERARY') }}
          </button>
        </div>

        <!-- Description Tab -->
        <div v-if="selectedTabIndex === 0" class="tab-content">
          
          <!-- Description text  -->
          <div v-html="eventDescriptionText" />

          <div class="videos-container">
            <div v-for="video in videos" :key="video.id" >
              <div class="single-video" v-html="video.html" />
            </div>
          </div>

          <!-- Info headlines -->
          <div v-if="included || excluded" class="included-container">
            <div v-if="included" style="flex: 1; padding: 10px;">
              <h3 class="subtitle">{{ getTranslation('WHAT_IS_INCLUDED') }}</h3>
              <div v-html="included" />
              <ul>
                <li v-for="inclusion in inclusions" :key="inclusion">{{ getTranslation(inclusion) }}</li>
              </ul>
            </div>
            <div v-if="excluded" style="flex: 1; padding: 10px;">
              <h3 class="subtitle">{{ getTranslation('WHAT_IS_NOT_INCLUDED') }}</h3>
              <div v-html="excluded" />
              <ul>
                <li v-for="exclusion in exclusions" :key="exclusion">{{ getTranslation(exclusion) }}</li>
              </ul>
            </div>
          </div>
          <div v-if="attention || requirements" class="included-container">
            <div v-if="attention" style="flex: 1; padding: 10px;">
              <h3 class="subtitle">{{ getTranslation('TAKE_NOTICE') }}</h3>
              <div v-html="attention" />
            </div>
            <div v-if="requirements" style="flex: 1; padding: 10px;">
              <h3 class="subtitle">{{ getTranslation('WHAT_SHOULD_I_BRING') }}</h3>
              <div v-html="requirements" />
            </div>
          </div>
          <div v-if="cancellationPolicy && cancellationPolicy.penaltyRules && cancellationPolicy.penaltyRules.length > 0" class="included-container">
            <div style="flex: 1; padding: 10px;">
              <h3 class="subtitle">{{ getTranslation('BOOKING_RULES') }}</h3>
              <p v-for="fee in cancellationPolicy.penaltyRules" :key="JSON.stringify(fee)">
                - {{ getTranslation('CANCELLATION_PART_1') }} {{ fee.charge }}% {{ getTranslation('CANCELLATION_PART_2') }} {{ Math.floor(fee.cutoffHours / 24) }} {{ getTranslation('CANCELLATION_PART_3') }}
              </p>
            </div>
          </div>

          <!-- Additional info - box -->
          <div class="additional-info-box">
            <div v-if="activityType || eventDifficulty" class="included-container">
              <div v-if="activityType" style="flex: 1; padding: 10px;">
                <h3 class="subtitle">{{ getTranslation('EXPERIENCE_TYPE') }}</h3>
                <p>{{ getTranslation(activityType) }}</p>
              </div>
              <div v-if="eventDifficulty" style="flex: 1; padding: 10px;">
                <h3 class="subtitle">{{ getTranslation('DIFFICULTY') }}</h3>
                <p>{{ getTranslation(eventDifficulty) }}</p>
              </div>
            </div>
            <div v-if="bookingCutoff" class="included-container">
              <div v-if="bookingCutoff" style="flex: 1; padding: 10px;">
                <h3 class="subtitle">{{ getTranslation('BOOKING_IN_ADVANCE') }}</h3>
                <p>{{ getTranslation('BOOK_BEFORE_PART_1') }} {{ Math.floor(bookingCutoff / 60) }} {{ getTranslation('BOOK_BEFORE_PART_2') }}</p>
              </div>
              <div v-if="(activityAttributes && activityAttributes.length > 0) || (activityCategories && activityCategories.length > 0)" style="flex: 1; padding: 10px;">
                <h3 class="subtitle">{{ getTranslation('CATEGORIES') }}</h3>
                <p>{{ activityAttributes.map(_ => getTranslation(_)).join(', ') + ', ' + activityCategories.map(_ => getTranslation(_)).join(', ') }}</p>
              </div>
            </div>
            <div v-if="eventLength || (guidanceTypes && guidanceTypes.length > 0)" class="included-container">
              <div v-if="eventLength" style="flex: 1; padding: 10px;">
                <h3 class="subtitle">{{ getTranslation('DURATION') }}</h3>
                <p>{{ minutesToTime(eventLength) }}</p>
              </div>
              <div v-if="guidanceTypes && guidanceTypes.length > 0" style="flex: 1; padding: 10px;">
                <h3 class="subtitle">{{ getTranslation('LIVE_GUIDE') }}</h3>
                <p
                  v-if="guidanceTypes.filter(_ => _.guidanceType === 'GUIDED') && guidanceTypes.filter(_ => _.guidanceType === 'GUIDED').length > 0">
                  {{ guidanceTypes.filter(_ => _.guidanceType === 'GUIDED')[0].languages.map(_ => getTranslation(_)).join(', ') }}
                </p>
              </div>
            </div>
            <div v-if="(guidanceTypes && guidanceTypes.length > 0)" class="included-container">
              <div v-if="false" style="flex: 1; padding: 10px;">
                <h3 class="subtitle">---</h3>
                <p>{{ '-----' }}</p>
              </div>
              <div v-if="guidanceTypes && guidanceTypes.length > 0 && guidanceTypes.filter(_ => _.guidanceType === 'READING_MATERIAL') && guidanceTypes.filter(_ => _.guidanceType === 'READING_MATERIAL').length > 0" style="flex: 1; padding: 10px;">
                <h3 class="subtitle">{{ getTranslation('WRITTEN_LANGUAGES_SUPPORTED') }}</h3>
                <p>
                  {{ guidanceTypes.filter(_ => _.guidanceType === 'READING_MATERIAL')[0].languages.map(_ => getTranslation(_)).join(', ') }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Transportation Tab -->
        <div v-if="selectedTabIndex === 1 && startPoints" class="tab-content">
          <div v-for="point in startPoints" :key="point.id">
            <div v-html="eventTransportationText" />
            <div class="included-container">
              <div style="flex: 1; padding: 10px;">
                <h3 class="subtitle">{{ point.title }}</h3>
                <p>{{ point.address.addressLine1 + (point.address.addressLine2 ? ' ' + point.address.addressLine2 : '') + (point.address.addressLine3 ? ' ' + point.address.addressLine3 : '') + ', ' + point.address.postalCode + ' ' + point.address.city }}</p>
                <iframe
                  width="100%"
                  height="400"
                  style="border:0"
                  loading="lazy"
                  :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyAjPXOJdh3eZFw7D_Fqv_DSYlsjRVWtJVk&q=' + ( point.address.addressLine1 + (point.address.addressLine2 ? ' ' + point.address.addressLine2 : '') + (point.address.addressLine3 ? ' ' + point.address.addressLine3 : '') + ', ' + point.address.postalCode + ' ' + point.address.city ).replace(/ /g, '+')">
                </iframe>
              </div>
            </div>
          </div>
        </div>

        <!-- Meeting Places Tab -->
        <div v-if="selectedTabIndex === 2" class="tab-content">
          <p>{{ getTranslation('MEETING_PLACES') }}</p>
          <div>
            <p style="margin-bottom: 0px; margin-top: 0px;" v-for="place in pickupPlaces" :key="place.id" >
              - {{ place.title }}
            </p>
          </div>
        </div>

        <!-- Itenary / AgendaItems Tab -->
        <div v-if="selectedTabIndex === 3" class="tab-content">
          <div v-for="agenda in eventItenary" :key="agenda.title">
            <h4>{{ agenda.title }}</h4>
            <div v-html="agenda.body" />
          </div>
        </div>

      </div>

      <!-- Shopping -->
      <div id="shopping" class="flex-column keep-wide-desktop" style="flex: 1;">

        <!-- Participants -->
        <div class="box" style="padding-bottom: 0px; padding-top: 0px;">
          <h3 class="box-title blue-text">{{ getTranslation('PARTICIPANTS') }}</h3>
          <ParticipantAmount
            v-for="participantOption in participantPossibilities"
            :key="participantOption.title"
            :participantOption="participantOption"
            :occupancySum="occupancySum"
            :getTranslation="getTranslation"
            :maxOccupancy="maxOccupancy"
            v-on:update-cart="props => $emit('update-cart', props)"
            v-on:update-calender="query => $emit('reload-calender', query)" />
        </div>

        <!-- Pick date -->
        <div class="box">
          <h3 class="box-title blue-text">{{ getTranslation('CHOOSE_A_DATE') }}</h3>
          <Calender
            :weeks="calenderWeeks"
            :selectedDate="selectedDate"
            :calendarLoading="calendarLoading"
            :calendarErrors="calendarErrors"
            :occupancySum="occupancySum"
            :selectedTime="selectedTime"
            :rateInfos="rateInfos"
            :hideRateSelection="hideRateSelection"
            :participants="participants"
            :getTranslation="getTranslation"
            :setSelectedTime="setSelectedTime"
            :selectedRate="selectedRate"
            :setSelectedRate="setSelectedRate"
            :activeMonth="activeMonth"
            :setActiveMonth="setActiveMonth"
            :activeYear="activeYear"
            :setActiveYear="setActiveYear"  
            v-on:update-calender="query => $emit('reload-calender', query)"
            v-on:update-cart="props => $emit('update-cart', props)" />
        </div>

        <!-- Summary -->
        <div class="box">
          <h3 class="box-title blue-text">{{ getTranslation('SUMMARY') }}</h3>
          <div class="order-verify">
            <div style="font-weight: 600; font-size: 16px; margin-bottom: 5px;" >{{ getTranslation('TICKETS') }}</div>
            <div v-for="(value, name) in participants" :key="name">            
              <p v-if="value.amount !== 0" style="margin-top: 0px; margin-bottom: 0px;">
                {{ value.title }} : {{ value.amount }}
              </p>
            </div>
            <div style="border-bottom: 1px solid #e5e5e5; margin-bottom: 15px; margin-top: 15px;" />
            <div style="font-weight: 600;  font-size: 16px;" >{{ getTranslation('DATE') }}</div>
            <p v-if="selectedDate" style="margin-top: 5px; margin-bottom: 0px;">{{
              new Date(selectedDate).getDate() + '.' + (new Date(selectedDate).getMonth() + 1) + '.' + (new Date(selectedDate).getYear() + 1900) + ' - ' + (selectedTime.time || '')
            }}</p>
            <div style="border-bottom: 1px solid #e5e5e5; margin-bottom: 15px; margin-top: 15px;" /> 
            <p v-if="selectedRate && selectedRate.price" style="font-size: 20px; font-weight: 600;">{{ selectedRate.price }}</p>      
            <div v-if="capacityType === 'ON_REQUEST'">
              <h3 class="blue-text">{{ getTranslation('READ_BEFORE_CONTINUE') }}</h3>
              <p>{{ getTranslation('ONLY_AVAILABLE_BY_REQUEST_1') }} {{
                (requestDeadlineWeeks ? (requestDeadlineWeeks + ' ' + getTranslation('WEEKS') + ' ') : '') +
                (requestDeadlineDays ? (requestDeadlineDays + ' ' + getTranslation('DAYS') + ' ') : '') +
                (requestDeadlineHours ? (requestDeadlineHours + ' ' + getTranslation('HOURS') + ' ') : '') +
                (requestDeadlineMinutes ? (requestDeadlineMinutes + ' ' + getTranslation('WEEKS') + ' ') : '')
              }}</p>
            </div>
            <button
              :disabled="!(selectedRate && selectedRate.price && selectedDate && selectedTime && selectedTime.time && selectedRate && selectedRate.price)"
              v-on:click="$emit('toggleCheckout')"
              :class="'buy ' + 'disabled-' + !(selectedRate && selectedRate.price && selectedDate && selectedTime && selectedTime.time && selectedRate && selectedRate.price)">
              {{
                checkoutLoading ?
                  getTranslation('LOADING') :
                  checkoutErrors ?
                    getTranslation('RELOAD') :
                    getTranslation('CONTINUE')
              }}
            </button>
            <div v-if="checkoutErrors" class="checkout-errors">
              {{ getTranslation('SOMETHING_HAPPENED') }}
              <br>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ParticipantAmount from './ParticipantAmount'
import Calender from './Calender'

export default {
  name: 'ActivityPage',
  props: {
    eventName: String,
    eventLength: Number,
    eventDifficulty: String,
    eventDescriptionText: String,
    eventMeetingPlacesText: String,
    eventTransportationText: String,
    startPoints: Array,
    selectedTime: Object,
    participantPossibilities: Array,
    activityType: String,
    languages: Array,
    cancellationPolicy: Object,
    rateInfos: Array,
    calenderWeeks: Array,
    calendarLoading: Boolean,
    selectedDate: String,
    participants: Object,
    eventItenary: Array,
    included: String,
    excluded: String,
    inclusions: Array,
    exclusions: Array,
    attention: String,
    requirements: String,
    pickupPlaces: Array,
    occupancySum: Number,
    maxOccupancy: Number,
    checkoutLoading: Boolean,
    calendarErrors: String,
    checkoutErrors: String,
    categories: Array,
    bookingCutoff: Number,
    excerpt: String,
    setSelectedTime: Function,
    selectedRate: Object,
    setSelectedRate: Function,
    activityAttributes: Array,
    activityCategories: Array,
    guidanceTypes: Array,
    getTranslation: Function,
    videos: Array,
    hideRateSelection: Boolean,
    capacityType: String,
    requestDeadlineDays: Number,
    requestDeadlineHours: Number,
    requestDeadlineMinutes: Number,
    requestDeadlineWeeks: Number,
    activeMonth: Number,
    setActiveMonth: Function,
    activeYear: Number,
    setActiveYear: Function  
  },
  components: {
    ParticipantAmount,
    Calender
  },
  data: function () {
    return {
      selectedTabIndex: 0,
    }
  },
  methods: {
    scrollToBooking: function () {
      let shoppingElement = document.getElementById('shopping')
      if (!shoppingElement) {
        const wacsElement = document.getElementsByTagName('wacs-widget') && document.getElementsByTagName('wacs-widget')[0]
        if (wacsElement && wacsElement.shadowRoot) {
          shoppingElement = wacsElement.shadowRoot.getElementById('shopping')
        }         
      }
      if (shoppingElement) {
        shoppingElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    },
    minutesToTime: function (mins) {
      let minutes = mins
      let hours = Math.floor(minutes / 60)
      let days = Math.floor(hours / 24)
      let timeString = ['','','']
      if (days > 0) {
        timeString[0] = days + ' ' + (days === 1 ? this.getTranslation('DAY') : this.getTranslation('DAYS'))      
        hours -= days * 24
        minutes -= days * 60 * 24
      }
      if (hours > 0) {
        timeString[1] = hours + ' ' + (hours === 1 ? this.getTranslation('HOUR') : this.getTranslation('HOURS'))        
        minutes -= hours * 60
      }
      if (minutes > 0) {
        timeString[2] = minutes + ' ' + (minutes === 1 ? this.getTranslation('MINUTE') : this.getTranslation('MINUTES'))
      }
      return timeString.join(' ')
    },
    setSelectedTabIndex: function (index) {
      this.selectedTabIndex = index
    },
    translateDifficulty: function (text) {
      if (text === 'EASY') return this.getTranslation('EASY')
      if (text === 'MODERATE') return this.getTranslation('MODERATE')
      if (text === 'HARD') return this.getTranslation('HARD')
      return this.getTranslation(text)
    },
    translateDifficultyImg: function (text) {
      if (text === 'EASY') return require('../assets/difficulty.png')
      if (text === 'MODERATE') return require('../assets/difficulty3.png')
      if (text === 'CHALLENGING') return require('../assets/difficulty4.png')
      if (text === 'HARD') return require('../assets/difficulty5.png')
      return require('../assets/difficulty.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.videos-container {
  padding: 20px;
  padding-left: 0px;
}
.book-now {
  display: none;
  width: 100%;
  border: 0px;
  padding: 15px;
  background-color: #0092C8;
  color: white;
  font-weight: 700;
  margin-bottom: 30px;
}
.activity-widget {
  animation-name: fade-in;
  animation-duration: 2s;
}
.small-icon {
  height: 20px;
  width: 20px;
  object-fit: contain;
}
.subtitle {
  font-size: 20px;
  font-weight: 700;  
  margin-bottom: -3px;
}
h3.subtitle {
  font-size: 20px;
  font-weight: 700;  
  margin-bottom: 5px;
}
.activity-title {
  font-size: 36px;
  font-weight: 700px;
}
.checkout-errors {
  padding-top: 10px;
}
.additional-info-box {
  border: 1px solid #f6f6f6;
  background-color: #f6f6f6;
  padding: 20px;
  padding-top: 0px;
  padding-bottom: 10px;
  margin-top: 20px;
  box-shadow: 0px 0px 7px rgb(235,235,235);
}
.mock-image {
  width: 100%;
}
.included-container {
  padding-top: 10px;
  padding: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.event-details {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.event-detail {
  padding-left: 5px;
  padding-right: 20px;
}
.order-verify {
  padding: 15px;
  padding-top: 20px;
  padding-bottom: 5px;
  color: rgb(52, 64, 78);
}
.widget-content {
  padding: 10px;
}
.tab-selector {
  display: flex;
  flex-direction: row;
  border-left: 1px solid rgba(0,0,0,0.1);
}
.tab-button {
  flex: 1;
  background-color: white;
  border: 0px solid white;
  border: 1px solid rgba(0,0,0,0.1);
  border-left: 0px;
  padding: 15px;
  color: rgb(130,130,130);
  font-weight: 600;
  text-align: center;
}
.tab-button:hover {
  color: rgb(0, 146, 200);
}
.tab-content {
  padding-top: 10px;
}
.selected-tab {
  border-bottom: 0px;
  border-top: 2px solid #0092C8;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(400px, 1fr) );
}
.grid-column {
  padding: 15px;
}
.flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.flex-column {
  padding: 15px;
}
.flex-break {
  flex-basis: 100%;
  height: 0;
}
.buy {
  background-color: #0092C8;
  border: 0px solid white;
  width: 100%;
  color: white;
  text-align: center;
  padding: 15px;
  margin-top: 5px;
  text-transform: uppercase;
  font-weight: 600;
}
.disabled-true {
  background-color: rgb(180,180,180);
}
.keep-wide-desktop {
  min-width: 400px;
}

@media only screen and (max-width: 450px) {
  .keep-wide-desktop {
    min-width: 250px;
  }
  .tab-button {
    padding: 8px;
    font-size: 11px;
  }
}

@media only screen and (max-width: 650px) {
  .book-now {
    display: block;
  }
  .single-video {
    transform: scale(0.8);
    margin-left: -30px;
  }
}
</style>
